<template>
  <div>
    <div>
      <div class="writeGridContainer mt-4">
        <div>
          <div>구분</div>
          <ml-input v-if="readonly" readonly v-model="form.category" />
          <vs-select v-else v-model="form.category" autocomplete>
            <vs-select-item v-for="item in categoryOptions" :key="item.id" :value="item.name" :text="item.name" />
          </vs-select>
        </div>
        <div class="block">
          <vs-button v-if="isAdmin && !readonly" @click="$store.commit('ui/OPEN_SIDECONFIG')" color="secondary" type="flat" icon-pack="feather" icon="icon-settings" class="w-auto">설정(관리자)</vs-button>
        </div>
        <div class="writeGridCol2">
          <div>제목</div>
          <ml-input :readonly="readonly" v-model="form.제목" />
        </div>
        <div></div>
        <div>
          <div>부서명</div>
          <ml-input readonly v-model="form.stdInfo.division" />
        </div>
        <div>
          <div>작성자</div>
          <ml-input readonly v-model="form.stdInfo.writer_name" />
        </div>
        <div>
          <div>등록일</div>
          <ml-input readonly v-model="form.stdInfo.date" />
        </div>

        <div class="writeGridLineItem">
          <div>내용</div>
          <quill-editor ref="quill" class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import { quillEditor } from "vue-quill-editor";
import moment from "moment";

const SIDE_CONFIG_KEY = "category_option_1108";

export default {
  components: {
    FileUploadModule,
    quillEditor,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      quillOption: {
        placeholder: "내용을 입력해주세요 ...",
      },

      form: {
        category: "",
        제목: "",
        stdInfo: {},
        content: "",
        fileList: [],
      },
    };
  },
  computed: {
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    postId() {
      return this.$route.params.postId;
    },
    categoryOptions() {
      const data = this.$store.state.ui.sideConfigMap[SIDE_CONFIG_KEY];
      return data || [];
    },
    readonly() {
      return this.board.readonly;
    },
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.postId) {
          const writer = value.writer;
          this.form.stdInfo = {
            division: writer.meta && writer.meta.division ? writer.meta.division : "",
            writer_name: writer.name,
            date: moment().format("YYYY-MM-DD"),
          };
        }
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    if (this.readonly) this.quillOption.modules = { toolbar: false };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.quill.quill.enable(false);
    });
  },
};
</script>
